import { getFilterMetadata } from '../../../components/StatelessComponent/FilterChainUtils';
import { OPTION_LIST } from '../../../components/StatelessComponent/SingleFilter/SurveyCompletionFilter/SurveyCompletionFilterConstant';
import type { SURVEY_COMPLETION_TYPE } from '../../../components/StatelessComponent/SingleFilter/SurveyCompletionFilter/SurveyCompletionFilterType';
import { FilterKindEnum } from '../../../domains/global-filters/model/FilterChain';
import type { LabelProps } from '../LabelFormatterType';

export function getLabels(currentValue?: SURVEY_COMPLETION_TYPE): LabelProps {
  const metadata = getFilterMetadata(FilterKindEnum.SurveyCompletionKind);
  return {
    label1: currentValue ? 'Survey' : metadata.filterName,
    label2: OPTION_LIST.find((item) => item.value === currentValue)?.label ?? '',
  };
}
